
import IconBase from './IconBase';

export default {
  name: 'InputSuccessIcon',
  extends: IconBase,
  data() {
    return {
      iconClass: 'fa fa-check-circle',
    };
  },
};
